export default __webpack_public_path__ + "static/media/eve-no-jikan.c10915b4.jpg";